import React from "react";
import { useLocation } from "react-router";
import Router from "./Router";
import DowntimeBanner from "../components/DowntimeBanner";
import { useAuth } from "../components/AuthContext/AuthContext";
import Header from "../components/Layout/Header";

const SELF_HEADER_PATHS = ["/store","/login","/forgot-password","/account-access","/account","/change-password","/email-confirmation"];

const Index = () => {
  const { featureFlag } = useAuth();
  const location = useLocation();

  const hasOwnHeader = SELF_HEADER_PATHS.includes(location.pathname);
  const showGlobalHeader = featureFlag && hasOwnHeader;

  return (
    <>
      <DowntimeBanner />
      {showGlobalHeader && <Header />}
      <Router />
    </>
  );
};

export default Index;